import { useEffect } from 'react';

import type { UsePurchasePlanningSettingsEffectsProps } from '@app/pages/Warehouses/PurchasePlanningSettings/types';

export const usePurchasePlanningSettingsEffects = ({
  getProductsLimitsFiltersDataHandler,
}: UsePurchasePlanningSettingsEffectsProps) => {
  useEffect(() => {
    getProductsLimitsFiltersDataHandler();
  }, [getProductsLimitsFiltersDataHandler]);
};
